export function getImageHeaderUrls(imageHeaderUrl: string | null | undefined) {
  return (imageHeaderUrl ?? "")
    .split(",")
    .map(url => url.trim())
    .filter(Boolean)
}

export function getFirstImageHeaderUrl(
  imageHeaderUrl: string | null | undefined,
) {
  return getImageHeaderUrls(imageHeaderUrl)[0] ?? null
}
